// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const PolygonOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"currentColor","viewBox":"0 0 256 256","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M230.63 49.37a32.05 32.05 0 00-45.26 0 31.85 31.85 0 00-5.15 6.76L152 48.43a32 32 0 00-54.6-23.06 32.05 32.05 0 00-5.75 37.41L57.68 93.33a32.06 32.06 0 00-40.31 4 32 32 0 0042.88 47.4l70 51.36a32 32 0 1052.34-10.76 31.51 31.51 0 00-4.78-3.92l27.39-77.59q1.38.12 2.76.12a32 32 0 0022.63-54.61zm-67.87 126.77a31.93 31.93 0 00-23 7.09l-70-51.36a32.13 32.13 0 00-1.33-26.65l33.94-30.55a32 32 0 0045.46-10.8l28.17 7.7a31.87 31.87 0 0014.11 27z"}}]},"name":"polygon","theme":"outlined"};

const PolygonOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={PolygonOutlinedSvg} />;
  PolygonOutlined.displayName = 'PolygonOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(PolygonOutlined);
